module.exports = __webpack_public_path__ + "img/tracking-settings.66e406fa.png";